import { render, staticRenderFns } from "./Automation.vue?vue&type=template&id=527c8250&scoped=true&"
var script = {}
import style0 from "./Automation.vue?vue&type=style&index=0&id=527c8250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527c8250",
  null
  
)

export default component.exports